
import { ReactNode } from 'react';

interface TopNavigationProps {
  title: string;
  leftAction?: ReactNode;
  rightAction?: ReactNode;
  showBack?: boolean;
  onBack?: () => void;
}

export default function TopNavigation({ 
  title, 
  leftAction, 
  rightAction, 
  showBack = false,
  onBack 
}: TopNavigationProps) {
  return (
    <div className="fixed top-0 left-0 right-0 bg-[#1565C0] text-white z-50">
      <div className="flex items-center justify-between h-14 px-4">
        <div className="flex items-center">
          {showBack && (
            <button 
              onClick={onBack}
              className="w-8 h-8 flex items-center justify-center ml-2"
            >
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
          )}
          {leftAction}
        </div>
        
        <h1 className="text-lg font-semibold text-center flex-1">{title}</h1>
        
        <div className="flex items-center">
          {rightAction}
        </div>
      </div>
    </div>
  );
}
